import {
  deleteDept,
  getAllDept,
  saveDept,
  updateDept
} from '../services/deptUserManage';
import { message } from 'antd';
import * as accountService from '../services/account';
import {PATHS, REPORT_ACTIVE_TYPE, RES_STATUS} from '../utils/constants';
export default {
  namespace: 'deptUserManage',
  state: {
    allDept: [],
    deptAddEditStatus: 0,
    userAddEditStatus: 0,
    users: [],
    current: 1,
    pageSize: 15,
    total: 0,
    keyType: 'name',
    keyword: '',
    selDeptNodeCode: ''
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *searchUsers(_, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const {
        current,
        pageSize,
        keyword,
        keyType,
        selDeptNodeCode
      } = yield select(state => state.deptUserManage);
      const { status, data, msg } = yield call(accountService.searchUser, {
        keyword: encodeURIComponent(keyword),
        keyType,
        current,
        pageSize,
        lang: locale,
        deptNodeCode: selDeptNodeCode
      });
      if (status === 0) {
        const { records: total = 0, rows: users = [] } = data;
        yield put({
          type: 'update',
          payload: { total, users, keyword, keyType, userAddEditStatus: 0 }
        });
      } else {
        throw new Error(msg);
      }
    },
    *delUser({ userId, intl }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { data, msg, status } = yield call(accountService.deleteUser, {
        userId,
        lang: locale
      });
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_USER,
        optResult: status,
        actContent: msg,
        data: data
      };
      if (status === 0) {
        yield put({
          type: 'searchUsers'
        });
        message.success(params.data);
      } else {
        message.error(params.actContent);
      }
      yield call(accountService.recordActivityLog, params);
    },

    userSaveOrUpdate: [function* ({ user }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { userId } = yield select(state => state.login.userInfo);

      const { data, msg, status } = yield call(accountService.saveOrUpdateUser, {
        user,
        lang: locale
      });
      const params = {
        operatorId: userId,
        actType: user.id
          ? REPORT_ACTIVE_TYPE.MOD_USER
          : REPORT_ACTIVE_TYPE.ADD_USER,
        optResult: status,
        actContent: msg,
        data: data
      };
      if (status === 0) {
        yield put({
          type: 'searchUsers'
        });
        message.success(params.data);
      } else {
        message.error(params.actContent);
      }
      yield call(accountService.recordActivityLog, params);
    }, { type: 'takeLatest' }],
    *resetPwd({ userId }, { call, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { data, msg, status } = yield call(accountService.resetPwd, {
        userId,
        lang: locale
      });
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.REST_PWD,
        optResult: status,
        actContent: msg,
        data: data
      };
      if (status === 0) {
        message.success(params.data);
      } else {
        message.error(params.actContent);
      }
      yield call(accountService.recordActivityLog, params);
    },
    *deleteDept({ deptId }, { call, put, select }) {
      let { token } = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const { data, status, msg } = yield call(deleteDept, { deptId, token, lang });
      if (status !== RES_STATUS.success) {
        message.error(msg);
      } else {
        message.success(data);
        yield put({
          type: 'getAllDept'
        });
      }
    },
    *updateDept({ deptId, name }, { call, put, select }) {
      let { token } = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const { data, status, msg } = yield call(updateDept, {
        deptId,
        name,
        token,
        lang
      });
      if (status !== RES_STATUS.success) {
        message.error(msg);
      } else {
        message.success(data);
        yield put({ type: 'getAllDept' });
        yield put({ type: 'searchUsers' });
      }
    },
    *saveDept({ parId, level, sonName }, { call, put, select }) {
      let { token } = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const { data, status, msg } = yield call(saveDept, {
        parId,
        level,
        sonName,
        token,
        lang
      });
      if (status !== RES_STATUS.success) {
        message.error(msg);
      } else {
        message.success(data);
        yield put({
          type: 'getAllDept'
        });
      }
    },
    *getAllDept(_, { call, put, select }) {
      let { token } = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const { status, msg, data } = yield call(getAllDept, { token, lang });
      if (status !== RES_STATUS.success) {
        message.error(msg);
        yield put({
          type: 'update',
          payload: { allDept: [], deptAddEditStatus: 0 }
        });
      } else {
        yield put({
          type: 'update',
          payload: { allDept: [data], deptAddEditStatus: 0 }
        });
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.deptUserManage) {
          dispatch({ type: 'getAllDept' });
          dispatch({ type: 'searchUsers' });
          dispatch({ type: 'role/findAllRoles' });
        } else {
          //离开组织用户管理界面时，清空搜索信息
          dispatch({
            type: 'update',
            payload: {
              keyword: '',
              keyType: 'name',
              current: 1,
              pageSize: 15,
              deptNodeCode: ''
            }
          });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/deptUserManage.js